/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Descrizione',
    END_DATE: 'Fino al',
    ID: 'ID',
    OBJECTIVE: 'Obiettivo',
    REWARD: 'Ricompensa',
    START_DATE: 'Dal'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Valore accumulato',
    ACTIVES: 'Attive',
    AT: 'Il',
    COUPON: 'Coupon',
    CREATED: 'Creata',
    DAY_VALUE: 'Valore del giorno',
    FAIL: 'Fallita',
    FINISHED: 'Finita',
    HISTORY: 'Cronologia',
    IN_PROGRESS: 'In corso',
    MONETARY_REWARD: 'Ricompensa',
    NR_ACCESSES: 'Nuovi accessi',
    NR_NEW_CLIENTS: 'Nuovi clienti',
    NR_ORDERS: 'Ordini',
    OBJECTIVE: 'Obiettivo',
    OBJECTIVE_VALUE: 'Valore dell\'obiettivo',
    OFFER: 'Premio',
    OPEN: 'Apri',
    REMUNERATION: 'Retribuzione',
    REWARD_TYPE: 'Tipo ricompensa',
    REWARD_TYPES: 'Tipi ricompensa',
    SALES: 'Vendite',
    SALES_BRANDS: 'Gamma da vendere (€)',
    SALES_BRANDS_QTY: 'Gamma da vendere (Qtà.)',
    SALES_CATEGORY: 'Categoria da vendere (€)',
    SALES_CATEGORY_QTY: 'Categoria da vendere (Qtà)',
    SALES_COMMISSIONS: 'Commissioni sulle vendita',
    SALES_PRODUCTS: 'Prodotti da vendere (€)',
    SALES_PRODUCTS_QTY: 'Prodotti da vendere (Qtà)',
    SUCCESS: 'Successo',
    TO: '{0} a {1}',
    TODAY: 'Oggi'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Nessuna sfida attiva (per il momento).',
    CHALLANGES_TITLE: 'Nessuna sfida.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
